import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/toaster.tsx";
import { Session } from "@stytch/vanilla-js";
import { User } from "@/lib/api/user.ts";
import { MobileBlocker } from "@/components/mobile-blocker.tsx";

interface RouterContext {
  stytchSession: Session | null;
  user: User | null;
  revokeSession: () => void;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <MobileBlocker>
      <Outlet />
      <Toaster />
    </MobileBlocker>
  ),
});
